import banner1 from '../images/banner1.png';
import hhh from '../images/hhh.png';
import hho from '../images/hho.png';
const teams = [

  {
    key: "Đội Harmony",
    name: "Đội Harmony",
    bg: "from-blue-400 to-blue-700",
    border: "border-blue-700",
    text: "text-blue-900",
    gradient: "bg-gradient-to-br from-blue-400 to-blue-700",
    selected: true,
    icon: hhh,
    captain: "Lâm Trung Hiệp",
    slogan:"TRUST YOUR CHOICES!"
  },
  {
    key: "Đội Heart",
    name: "Đội Heart",
    bg: "from-orange-400 to-orange-700",
    border: "border-orange-400",
    text: "text-orange-900",
    gradient: "bg-gradient-to-br from-orange-300 to-orange-500",
    selected: false,
    icon: hho,
    captain: "Lê Thị Thùy Phương",
    slogan: "VHE - Nối kết bản lĩnh, chạm đỉnh vinh quang",
  },
  {
    key: "Đội House",
    name: "Đội House",
    bg: "from-green-400 to-green-700",
    border: "border-green-400",
    text: "text-green-900",
    gradient: "bg-gradient-to-br from-green-300 to-green-500",
    selected: false,
    icon: banner1,
    captain: "Lê Phạm Công Hoang",
    slogan: "ALL IN, ALL HOUSE - CHƠI HẾT MÌNH, CHO HOUSE HẾT LÒNG."
  },
  {
    key: "Đội Aurora",
    name: "Đội Aurora",
    bg: "from-blue-100 to-blue-300",
    border: "border-blue-200",
    text: "text-blue-900",
    gradient: "bg-gradient-to-br from-blue-100 to-blue-300",
    selected: false,
    icon: banner1,
    captain: "Nguyễn Trọng Nghĩa",
    slogan: "Aurora- Năng lượng bức phá"
  },
];

export default teams;